import { ChangeEvent, ReactNode } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";

interface MasterDialogProps {
  open: boolean;
  title: string;
  saving: boolean;
  isActive: boolean;
  onActiveChange: (isActive: boolean) => void;
  onClose: () => void;
  onSave: () => void;
  children: ReactNode;
}

/**
 * The create / edit dialog both code lists share. There is no delete: a code switched off stays
 * on the documents that used it and is no longer offered for new ones.
 */
export default function MasterDialog({
  open,
  title,
  saving,
  isActive,
  onActiveChange,
  onClose,
  onSave,
  children,
}: Readonly<MasterDialogProps>) {
  const handleActiveChange = (event: ChangeEvent<HTMLInputElement>) => onActiveChange(event.target.checked);

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <Stack gap={2}>
          {children}
          <FormControlLabel
            control={<Switch checked={isActive} onChange={handleActiveChange} />}
            label={isActive ? "ใช้งาน" : "ปิดใช้งาน"}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button disabled={saving} onClick={onClose}>
          ยกเลิก
        </Button>
        <Button variant="contained" loading={saving} onClick={onSave}>
          บันทึก
        </Button>
      </DialogActions>
    </Dialog>
  );
}
